import React, { useState } from "react";
import styles from "./DeviceTable.module.scss";
import download from "../../assets/icons/download.svg";
import downloadHover from "../../assets/icons/download-hover.svg";
import cancel from "../../assets/icons/disable.svg";
import cancelHover from "../../assets/icons/cancel-hover.svg";
import { useTranslation } from "react-i18next";

import eye from "../../assets/icons/eye-black.svg";
import CopyToClipboard from "../CopyToClipboard/CopyToClipboard";
import { trackEvent } from "../../utils/analytics";
import { EVENT_NAMES } from "../../types/event-names";

interface DeviceItemProps {
  item: {
    machine_name?: string;
    machine_id?: string;
    os_name?: string;
    downloadLink?: string;
  };
  trial?: boolean;
  itemKey?: string;
  anyMatchKey?: boolean;
  setCurrentDeviceDeactivate: (device: any) => void;
  setIsModalDeactivateVisible: (visible: boolean) => void;
  showToast: (message: string) => void;
}

const DeviceItem: React.FC<DeviceItemProps> = ({
  item,
  trial,
  itemKey,
  anyMatchKey,
  setCurrentDeviceDeactivate,
  setIsModalDeactivateVisible,
  showToast,
}) => {
  const { t } = useTranslation();

  const [showTooltip, setShowTooltip] = useState(false);
  const [showFullText, setShowFullText] = useState(false);

  const fullText = item.machine_name || item.machine_id || "";
  const isTruncated = fullText.length > 15;
  const displayText = isTruncated ? fullText.substring(0, 15) + "..." : fullText;
  return (
    <div className={styles.root_list}>
      <div>
        <p
          title={item?.machine_name || item?.machine_id || ""}
          onClick={() => setShowFullText(!showFullText)}
          style={{ wordBreak: "break-all" }}
        >
          {showFullText ? fullText : displayText}
        </p>
      </div>

      <div>
        <p>{item?.os_name}</p>
      </div>
      <div>
        <img
          className={styles.root_list_download}
          src={download}
          onMouseOver={(e) => (e.currentTarget.src = downloadHover)}
          onMouseOut={(e) => (e.currentTarget.src = download)}
          alt="download"
          width={24}
          height={24}
          onClick={() => {
            trackEvent(EVENT_NAMES.INSTALL_DOWNLOADED, {
              source: "devices",
              sourceScreen: "devices",
              deviceType: item?.os_name,
            });
            showToast(t("Install by clicking the download file"));
            setTimeout(() => {
              window.open(item?.downloadLink, "_blank");
            }, 300);
          }}
        />
      </div>

      {anyMatchKey && (
        <>
          {itemKey && (
            <div
              className={styles.root_list_cancel}
              onMouseOver={() => {
                setShowTooltip(true);
              }}
              onMouseOut={() => {
                setShowTooltip(false);
              }}
            >
              <img src={eye} alt="eye" className={styles.root_main_block_eye} />

              {showTooltip && (
                <div className={styles.root_tooltipKeyWrapper}>
                  <CopyToClipboard text={itemKey} layout="slim" />
                </div>
              )}
            </div>
          )}

          {!itemKey && <div className={styles.root_list_noKey}>-</div>}
        </>
      )}

      {!trial && (
        <div>
          <img
            className={styles.root_list_cancel}
            src={cancel}
            onMouseOver={(e) => (e.currentTarget.src = cancelHover)}
            onMouseOut={(e) => (e.currentTarget.src = cancel)}
            alt="cancel"
            onClick={() => {
              setCurrentDeviceDeactivate(item);
              setIsModalDeactivateVisible(true);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DeviceItem;
